import {
	HttpTransportType,
	HubConnectionBuilder,
	LogLevel,
} from "@microsoft/signalr";
import { CONFIG } from "../config";

export const createHubConnection = (hub: string) =>
	new HubConnectionBuilder()
		.configureLogging(LogLevel.None)
		.withUrl(`${CONFIG?.BASE_URL}/hubs/${hub}`, {
			withCredentials: true,
			skipNegotiation: true,
			accessTokenFactory: () => localStorage.getItem("token") || "",
			transport: HttpTransportType.WebSockets, // Skip negotiation, use WebSockets only
		})
		.withAutomaticReconnect()
		.build();
